import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  *,
  html,
  body,
  figure {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-family: "Source Sans Pro", sans-serif;
  }

  a {
    color: #1249A1;
  }

  a:hover {
    text-decoration: underline;
  }

  button:focus,
  a:focus,
  input:focus,
  select:focus,
  textarea:focus {
    outline: 2px solid #047ca4;
  }

  input,
  textarea {
    color: #1C1B1F;
  }
`;
